import { createAsyncThunk } from '@reduxjs/toolkit'
import i18n from 'i18next'

import { getTranslations } from '../api'
import { setTranslations } from '../api/setTranslations'
import { NAME } from '../configs'
import { prepareTranslations } from '../helpers'
import { ITranslation, ITranslationState } from '../models'
import { selectCurrentLocale } from '../selectors'

export const updateTranslations = createAsyncThunk(
  `${NAME}/updateTranslations`,
  async ({ key, value }: ITranslation, thunkApi) => {
    const state = thunkApi.getState() as { translations: ITranslationState }
    const currentLocale = selectCurrentLocale(state)

    const result = await setTranslations(key, value, currentLocale)
    if (result) {
      const translation = await getTranslations(currentLocale)
      const preparedTranslation = prepareTranslations(translation)

      i18n.addResourceBundle('0', 'translation', preparedTranslation, true, true)
    }
  }
)
